module.exports = __webpack_public_path__ + "static/img/arowRight.92635e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/arowRight.svg
// module id = Eiu5
// module chunks = 0